module.exports = __webpack_public_path__ + "img/error-404-pagina.29ce8182.jpg";